import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoundService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // [GET] tournament rounds
  public getTournamentRounds(tournamentId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.tournamentRounds, ':tournament', tournamentId), {
        params: {}, observe: 'response'
      });
  }

  // [POST] create tournament rounds
  public createTournamentRounds(tournamentId: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':tournament', tournamentId]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.tournamentRoundsCreate
    );
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + apiEndpoint, {
        params: {}, observe: 'response'
      });
  }

  // [GET] check if all matches have FINISHED status
  public checkRoundsFinished(tournamentId: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':tournament', tournamentId]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.roundsFinished
    );
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + apiEndpoint, {
        params: {}, observe: 'response'
      });
  }
}
